import { httpClient } from "@utils";
import { getApiRequestContext } from "@utils/api-config";
import { getApplicationRequestHeaders } from "@utils/api-config/getApplicationRequestHeader";

export class TvInfoApiService {
	static baseUrl = `${WEBPACK_BASE_ADDRESS}platform/events/tv-information`;
	static getRequestHeaders = (context = getApiRequestContext()) => {
		const appHeaders = getApplicationRequestHeaders(context);
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		return appHeaders;
	};

	static async getTvInfo(eventId: string) {
		const query = new URLSearchParams();
		query.set("rpp", "1");
		query.set("page", "1");
		query.set("translate", "true");
		query.set("ids", eventId);

		const result = await httpClient.get(
			`${this.baseUrl}?${query}`,
			this.getRequestHeaders()
		);

		if (result && result.item != null && result.item[0] != null) {
			return result.item[0].info;
		}

		return "";
	}
}
